import type { ObservationBundle } from "src/types/observationLaboratory";

export function getBundleCollectedDate(
  bundle: ObservationBundle
): string | undefined {
  const diagnosticReportDates = (bundle.entry ?? [])
    .filter((entry) => entry.resource?.resourceType === "DiagnosticReport")
    .map((entry) => entry.resource?.effectiveDateTime);

  return diagnosticReportDates.find((date) => Boolean(date));
}
